var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start text-gray-400 animate-pulse w-full justify-center",class:[`my-${_vm.margin}`, _vm.noPadding ? 'p-0' : 'p-4']},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":_vm.height,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }